import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const circle = { height: 16, width: 16, borderRadius: 8 };

export default StyleSheet.create({
  subHeaderTitle: { fontSize: 25.1, lineHeight: 31.4 },
  subHeaderSubTitle: {
    fontSize: 18.8,
    lineHeight: 25.1,
    fontFamily: Fonts.type.VFFont,
    fontWeight: 'normal',
  },
  container: { marginLeft: 0, marginBottom: 0 },
  contentContainer: {
    paddingHorizontal: 16.6,
    paddingTop: 32.4,
    paddingBottom: 120,
  },
  rightText: { paddingTop: 0, lineHeight: 16, color: Colors.secondary7 },
  subtitle: { marginBottom: 30 },
  VFButton: { marginBottom: 33.4, height: 49 },
  sectionContainer: theme => ({
    borderLeftWidth: 1,
    borderColor: theme.colors.inActiveColorTwo,
    paddingBottom: 21,
    marginLeft: 10.4,
    paddingHorizontal: 10,
  }),
  withRedBorder: theme => ({ borderColor: theme.colors.secondryColor }),
  withTransparentBorder: { borderColor: Colors.transparent },
  stepContentContainer: theme => ({
    marginTop: 20,
    marginStart: 12.5,
    padding: 17,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: Platform.OS === 'ios' && Colors.linegrey,
    elevation: 2,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  stepDataContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepIcon: { marginEnd: 16.4 },
  stepTitle: { fontSize: 16.7 },
  stepDate: { fontSize: 16.7, marginTop: 12, ...Fonts.type.bold },
  stepButtonsContainer: theme => ({
    flexDirection: 'row',
    paddingTop: 16,
    marginTop: 18,
    borderTopColor: theme.colors.horizontalLineColor,
    borderTopWidth: 1,
  }),
  stepButtonsSpace: { width: 20 },
  stepButton: { flexGrow: 1, flexBasis: 0, height: 33 },
  header: { flexDirection: 'row' },
  activeCircle: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    borderColor: theme.colors.secondryColor,
    borderRadius: 20,
    borderWidth: 1,
    marginLeft: -21,
    padding: 2,
  }),
  completedCircle: theme => ({
    ...circle,
    backgroundColor: theme.colors.secondryColor,
    marginLeft: -18,
  }),
  newCircle: theme => ({
    ...circle,
    backgroundColor: theme.colors.inActiveColorTwo,
    marginLeft: -18,
  }),
  activeInnerCircle: theme => ({
    ...circle,
    backgroundColor: theme.colors.secondryColor,
    marginTop: 0.5,
    marginLeft: 0,
  }),
  headerText: {
    fontSize: 16,
    marginStart: 15,
    marginEnd: 5,
    marginTop: -2,
    lineHeight: 25.1,
  },
  activeHeaderText: { ...Fonts.type.bold, marginStart: 12 },
});
